/**
 * What the shell renders until the first feature module lands.
 *
 * Deliberately not a port of `not-found.tsx`: that page belongs to
 * `manager-auth` and gets built with the rest of its module. Anything shown
 * here would be mistaken for it.
 */
export function ScaffoldNotice() {
  return (
    <main
      data-testid="scaffold-notice"
      className="flex min-h-screen items-center justify-center bg-neutral-950 p-8 text-neutral-300"
    >
      <div className="max-w-md space-y-2 text-center">
        <h1 className="text-lg font-medium text-neutral-100">AGOS Manager</h1>
        <p className="text-sm">
          Shell scaffold. No feature module is composed yet - see FRONTEND-STATUS.md.
        </p>
      </div>
    </main>
  )
}
